module.exports = __webpack_public_path__ + "img/juice.54527cc0.svg";